import AppWarn from './errors/app-warns'
import http from './webhook/httpconfig'
import { cancelHTTPRequests } from '@/services/utils'
import { generateHeaders } from './webhook/webhook'

export async function getBotDetails() {
  let botData = {}
  try {
    const response = await http.request({
      method: 'get',
      url: `/api/resources/bots`,
      headers: {
        'Cache-Control': 'no-cache',
        ...generateHeaders()
      },
      cancelToken: cancelHTTPRequests()
    })
    botData = response.data?.payload
  } catch (err) {
    throw new AppWarn({
      name: 'Get bot details',
      message: `Error while fetching bot details. ${err.message}`
    })
  }
  return botData
}

export async function getLastRequestId() {
  let requestId = null
  try {
    const response = await http.request({
      method: 'get',
      url: `/api/resources/last-request-id`,
      headers: {
        'Cache-Control': 'no-cache',
        ...generateHeaders()
      },
      cancelToken: cancelHTTPRequests()
    })
    requestId = response.data?.payload?.lastRequestId
  } catch (err) {
    throw new AppWarn({
      name: 'Last RequestID',
      message: `Error while fetching last requestId. ${err.message}`
    })
  }
  return requestId
}
export async function getBotPCIPolicy() {
  try {
    const response = await http.request({
      method: 'get',
      url: `/api/v1/bot-pci-policy`,
      headers: {
        'Cache-Control': 'no-cache',
        ...generateHeaders()
      },
      cancelToken: cancelHTTPRequests()
    })
    return response.data?.payload?.maskingFieldSetting || {}
  } catch (err) {
    console.error(err)
    throw new AppWarn({
      name: 'Bot PCI Policy',
      message: `Error while fetching Bot PCI Policy ${err.message}`
    })
  }
}
